import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2cf959dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "input-group custom-file-button" };
const _hoisted_2 = ["for"];
const _hoisted_3 = /*#__PURE__*/ _createTextVNode(" Choose File");
const _hoisted_4 = { key: 0 };
const _hoisted_5 = ["id", "multiple", "accept"];
const _hoisted_6 = {
    key: 0,
    class: "text-danger"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
            class: "input-group-text",
            for: _ctx.id
        }, [
            _hoisted_3,
            (_ctx.multiple)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(s)"))
                : _createCommentVNode("", true)
        ], 8, _hoisted_2),
        _createElementVNode("input", {
            ref: "fileinput",
            type: "file",
            class: "form-control",
            id: _ctx.id,
            multiple: _ctx.multiple,
            onChange: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args))),
            accept: _ctx.accept
        }, null, 40, _hoisted_5),
        _createVNode(_component_FormElementDescription, null, {
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.acceptableFileTypesMsg) + ". ", 1),
                (_ctx.errorMsg !== '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.errorMsg) + ".", 1))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ]));
}
